<template>
  <div class="service wrap">
    <SlotPageVisual class="half">
      <template #visual-bg>
        <div class="img consulting"></div>
      </template>
      <template #contents>
        <h1 class="visual-title">
          <span data-aos="fade"><span class="hl">C</span>onsulting</span>
        </h1>
        <p class="visual-summary">
          <span data-aos="fade-up" data-aos-delay="500">
            {{ $t('consulting.desc.01') }}
          </span>
          <br />
          <span data-aos="fade-up" data-aos-delay="1000">
            {{ $t('consulting.desc.02') }}
          </span>
        </p>
      </template>
    </SlotPageVisual>

    <MenuLinkGrid :items="consultingItems" />
  </div>
</template>

<script>
import SlotPageVisual from '@/components/SlotPageVisual'
import MenuLinkGrid from '@/components/MenuLinkGrid'

export default {
  name: 'ConsultingView',
  components: { SlotPageVisual, MenuLinkGrid },
  computed: {
    consultingItems () {
      return [
        {
          title: this.$t('consulting.title.operation'),
          sub: 'Implementation & Operation',
          desc: this.$t('consulting.detail.operation.subTitle'),
          to: '/consulting/operation',
          accent: '#2563eb'
        },
        {
          title: this.$t('consulting.title.client'),
          sub: 'Client Operation',
          desc: this.$t('consulting.detail.client.subTitle'),
          to: '/consulting/client',
          accent: '#7c3aed'
        },
        {
          title: this.$t('consulting.title.server'),
          sub: 'Server Management',
          desc: this.$t('consulting.detail.server.subTitle'),
          to: '/consulting/server',
          accent: '#0891b2'
        },
        {
          title: this.$t('consulting.title.monitoring'),
          sub: 'Monitoring & Security',
          desc: this.$t('consulting.detail.monitoring.subTitle'),
          to: '/consulting/monitoring',
          accent: '#dc2626'
        }
      ]
    }
  }
}
</script>
